import { getListReportDepositPromotionCompanyCarlinkAPI, getListReportDepositPromotionCompanyCarlinkExcelAPI } from "../../../api/report";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ParamsReport, ReportDepositPromotionCompanyCarlink } from "../../../types/report";
import { Constant } from "../../../config/constant";
import { toast } from "react-toastify";

const limit_pagination: any = window.localStorage.getItem("limit_pagination");
const limitPagination = isNaN(Number(limit_pagination))
    ? Constant.PAGE_SIZE
    : Number(limit_pagination);

const initialState = {
    listReport: [],
    loading: false,
    pagination: {
        total: 0,
        per_page: limitPagination,
        current_page: Constant.DEFAULT_PAGE,
        last_page: Constant.DEFAULT_PAGE,
    },
    total_prices_paid_at_company: 0,
    total_prices_agent_balance: 0,
    total_commissions: 0,
    total_prices: 0,
    filter: {
        options: "request_time",
        from: '',
        to: '',
        company_id: undefined,
    }
} as ReportDepositPromotionCompanyCarlink;

export const reportDepositPromotionCompanyCarlinkSlice = createSlice({
    name: 'reportDepositPromotionCompanyCarlink',
    initialState,
    reducers: {
        setFilterOptions(state, action: PayloadAction<string>) {
            state.filter.options = action.payload;
        },
        setFilterRangeDate(state, action: PayloadAction<any>) {
            state.filter.from = action.payload?.[0];
            state.filter.to = action.payload?.[1];
        },
        setFilterCompany(state, action: PayloadAction<number | undefined>) {
            state.filter.company_id = action.payload;
        },
        setPerPage(state, action: PayloadAction<number>) {
            state.pagination.per_page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getListReportDepositPromotionCompanyCarlink.pending, (state) => {
                state.loading = true;
            }).addCase(getListReportDepositPromotionCompanyCarlink.fulfilled, (state, action) => {
                state.loading = false;
                state.listReport = action?.payload?.data;
                state.pagination.total = action.payload?.pagination?.total;
                state.pagination.per_page = action.payload?.pagination?.per_page;
                state.pagination.last_page = action.payload?.pagination?.last_page;
                state.pagination.current_page = action.payload?.pagination?.current_page;
                state.total_prices = action.payload?.total_prices;
            }).addCase(getListReportDepositPromotionCompanyCarlink.rejected, (state, action: any) => {
                const listErros = action?.payload?.response?.data?.errors;
                if (listErros) {
                    Object.keys(listErros)?.forEach((fieldName) => {
                        toast.error(`${[listErros[fieldName]]}`);
                    });
                }
                state.loading = false;
            }).addCase(getListReportDepositPromotionCompanyCarlinkExcel.pending, (state) => {
            }).addCase(getListReportDepositPromotionCompanyCarlinkExcel.fulfilled, (state, action) => {
            }).addCase(getListReportDepositPromotionCompanyCarlinkExcel.rejected, (state, action: any) => {
                const listErros = action?.payload?.response?.data?.errors;
                if (listErros) {
                    Object.keys(listErros)?.forEach(fieldName => {
                        toast.error(`${[listErros[fieldName]]}`)
                    })
                }
            })
    }
})

export const getListReportDepositPromotionCompanyCarlink = createAsyncThunk('ReportDepositPromotionCompanyCarlink/getAll', async (params: ParamsReport, {
    dispatch, rejectWithValue
}) => {
    try {
        const response = await getListReportDepositPromotionCompanyCarlinkAPI(params)
        if (response) {
            return response?.data;
        }
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const getListReportDepositPromotionCompanyCarlinkExcel = createAsyncThunk('ReportDepositPromotionCompanyCarlink/getAllExcel', async (params: ParamsReport, {
    dispatch, rejectWithValue
}) => {
    try {
        const response = await getListReportDepositPromotionCompanyCarlinkExcelAPI(params)
        if (response) {
            return response?.data;
        }
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const { setFilterOptions, setFilterRangeDate, setFilterCompany, setPerPage } = reportDepositPromotionCompanyCarlinkSlice.actions;